interface SubtitleTextProps {
  content: string;
}

/**
 * Shared subtitle component to avoid CSS duplication
 */
export const SubtitleText = ({ content }: SubtitleTextProps) => (
  <p className="text-fg-muted sm-normal leading-[normal]">{content}</p>
);
